const isAdmin = () => {
  if (!window.localStorage || !window.localStorage.entitlements) return false
  const rules = ['ADMIN', 'SYSADMIN']
  const entitlements = window.localStorage.entitlements.split(',')
  return rules.some((rule) => entitlements.includes(rule))
}

const isGR = () => {
  if (!window.localStorage || !window.localStorage.entitlements) return false
  const rules = ['MANAGER']
  const entitlements = window.localStorage.entitlements.split(',')
  return rules.some((rule) => entitlements.includes(rule))
}

const isRtv = () => {
  if (!window.localStorage || !window.localStorage.entitlements) return false
  const rules = ['OPERATIONAL']
  const entitlements = window.localStorage.entitlements.split(',')
  return rules.some((rule) => entitlements.includes(rule))
}

const isExternalPromoter = () => {
  if (!window.localStorage || !window.localStorage.entitlements) return false
  const rules = ['OPERATIONAL', 'GUEST']
  const entitlements = window.localStorage.entitlements.split(',')
  return rules.some((rule) => entitlements.includes(rule))
}

const isMemberLevel = () => {
  if (!window.localStorage || !window.localStorage.entitlements) return false
  const rules = ['OPERATIONAL', 'GUEST']
  const entitlements = window.localStorage.entitlements.split(',')
  return rules.some((rule) => entitlements.includes(rule))
}

export { isAdmin, isExternalPromoter, isGR, isMemberLevel, isRtv }
